<nz-drawer
  [nzVisible]="visible"
  [nzWidth]="drawerWidth"
  [nzClosable]="true"
  [nzMaskClosable]="true"
  [nzWrapClassName]="wrapClass"
  nzPlacement="right"
  [nzTitle]="null"
  (nzOnClose)="onClose()">

  <ng-container *nzDrawerContent>
    <div class="monitor-container" [class.fullscreen]="fullscreen" [class.with-sidebar]="showSidebar">

      <header class="monitor-header">
        <div class="monitor-header__top">
          <div class="monitor-header__title">
            <span nz-icon nzType="thunderbolt" nzTheme="outline" class="monitor-header__icon"></span>
            <h3>
              {{ (source === 'executor' && aggregate?.title) || state.title || 'Execucao de fluxo' }}
            </h3>
            <small *ngIf="source === 'executor' && aggregate" class="aggregate-summary">
              {{ aggregateHeader }}
            </small>
          </div>
          <div class="monitor-header__actions">
            <button
              nz-button
              nzType="text"
              nz-tooltip
              [nzTooltipTitle]="fullscreen ? 'Reduzir' : 'Tela cheia'"
              (click)="toggleFullscreen()">
              <span nz-icon [nzType]="fullscreen ? 'shrink' : 'arrows-alt'"></span>
            </button>
            <button
              nz-button
              nzType="text"
              nz-tooltip
              [nzTooltipTitle]="isRunning ? 'Fechar (a execução continua no servidor)' : 'Fechar'"
              (click)="onClose()">
              <span nz-icon nzType="close"></span>
            </button>
          </div>
        </div>

        <div class="monitor-header__meta">
          <nz-tag [nzColor]="statusColor" class="status-tag">
            <span *ngIf="isRunning" nz-icon nzType="loading" nzTheme="outline"></span>
            <span *ngIf="state.status === 'COMPLETED'" nz-icon nzType="check-circle" nzTheme="outline"></span>
            <span *ngIf="state.status === 'ERROR'" nz-icon nzType="close-circle" nzTheme="outline"></span>
            <span *ngIf="state.status === 'STOPPED'" nz-icon nzType="stop" nzTheme="outline"></span>
            {{ statusLabel }}
          </nz-tag>
          <span class="elapsed">
            <span nz-icon nzType="clock-circle" nzTheme="outline"></span>
            {{ elapsedFormatted }}
          </span>
          <span *ngIf="state.idconf" class="idconf">IDCONF #{{ state.idconf }}</span>
          <span *ngIf="state.contextoAcao" class="action-tag">{{ state.contextoAcao }}</span>
        </div>
      </header>

      <section class="monitor-stats">
        <div class="stat-card">
          <div class="stat-card__label">
            {{ source === 'executor' ? 'Linhas (total)' : 'Linhas enviadas' }}
          </div>
          <div class="stat-card__value">
            {{ source === 'executor' ? (aggregate?.totals?.rowsCount ?? 0) : state.rowsCount }}
          </div>
        </div>
        <div class="stat-card" *ngIf="source === 'executor'">
          <div class="stat-card__label">Linhas OK</div>
          <div class="stat-card__value">{{ aggregate?.totals?.rowsOk ?? 0 }}</div>
        </div>
        <div class="stat-card" *ngIf="source !== 'executor'">
          <div class="stat-card__label">Steps executados</div>
          <div class="stat-card__value">{{ state.steps?.length || 0 }}</div>
        </div>
        <div class="stat-card" [class.has-error]="hasErrors">
          <div class="stat-card__label">Erros</div>
          <div class="stat-card__value">
            {{ source === 'executor' ? (aggregate?.totals?.rowsErr ?? 0) : errorsCount }}
          </div>
        </div>
      </section>

      <!-- Layout multi-job: sidebar a esquerda + conteudo a direita -->
      <div *ngIf="showSidebar; else singleJobContent" class="monitor-body">
        <aside class="monitor-jobs-sidebar">
          <div class="jobs-sidebar__title">Jobs ({{ jobsCount }})</div>
          <ul class="jobs-list">
            <li
              *ngFor="let j of jobsList; trackBy: trackJob"
              class="job-item"
              [class.selected]="selectedJobId === j.jobId"
              (click)="selectJob(j.jobId!)"
              tabindex="0"
              role="button"
              (keydown.enter)="selectJob(j.jobId!)">
              <nz-tag [nzColor]="jobStatusColor(j)" class="job-item__tag">
                <span *ngIf="j.status === 'RUNNING' || j.status === 'PENDING'" nz-icon nzType="loading"></span>
                <span *ngIf="j.status === 'COMPLETED'" nz-icon nzType="check-circle"></span>
                <span *ngIf="j.status === 'ERROR'" nz-icon nzType="close-circle"></span>
                <span *ngIf="j.status === 'STOPPED'" nz-icon nzType="stop"></span>
                {{ j.status }}
              </nz-tag>
              <div class="job-item__body">
                <div class="job-item__label">{{ j.label || ('IDCONF ' + (j.idconf ?? '?')) }}</div>
                <div class="job-item__meta">
                  <span>{{ j.rowsCount }} reg.</span>
                  <span *ngIf="j.strategy" class="job-item__strategy">{{ j.strategy }}</span>
                </div>
                <div *ngIf="(j.rowsOk ?? 0) > 0 || (j.rowsErr ?? 0) > 0" class="job-item__counters">
                  <span class="ok">{{ j.rowsOk }} OK</span>
                  <span *ngIf="(j.rowsErr ?? 0) > 0" class="err">{{ j.rowsErr }} erro</span>
                </div>
              </div>
            </li>
          </ul>
        </aside>
        <div class="monitor-content">
          <ng-container *ngTemplateOutlet="singleJobContent"></ng-container>
        </div>
      </div>

      <ng-template #singleJobContent>

      <section *ngIf="isRunning" class="running-banner">
        <ng-container *ngIf="liveTotal && liveTotal > 0; else progressIndeterminado">
          <nz-progress
            [nzPercent]="livePercent ?? 0"
            nzStrokeColor="#1890ff"
            nzStatus="active"
            [nzShowInfo]="false">
          </nz-progress>
          <p class="phase-message">{{ liveProcessed }} de {{ liveTotal }} processados</p>
        </ng-container>
        <ng-template #progressIndeterminado>
          <nz-progress
            [nzPercent]="100"
            nzStrokeColor="#1890ff"
            nzStatus="active"
            [nzShowInfo]="false">
          </nz-progress>
          <p class="phase-message">{{ phaseMessage }}</p>
        </ng-template>
        <p class="phase-hint">
          A timeline detalhada de steps sera exibida quando o fluxo terminar.
        </p>
      </section>

      <section *ngIf="state.status === 'ERROR' && state.errorMessage" class="error-banner">
        <nz-alert
          nzType="error"
          nzShowIcon
          nzMessage="Falha na execucao"
          [nzDescription]="state.errorMessage">
        </nz-alert>
      </section>

      <section *ngIf="!isRunning && state.steps?.length" class="steps-section">
        <h4>
          <span nz-icon nzType="unordered-list" nzTheme="outline"></span>
          Timeline de execucao
        </h4>

        <div *ngIf="stepsOverflow > 0" class="steps-overflow-notice">
          Mostrando os ultimos 200 de {{ state.steps.length }} passos
        </div>

        <div class="steps-timeline">
          <div
            *ngFor="let s of visibleSteps; trackBy: trackStep; let i = index"
            class="step-item"
            [class.selected]="selected?.key === s.key"
            [class.has-error]="s.error"
            (click)="selectStep(s)"
            tabindex="0"
            role="button"
            (keydown.enter)="selectStep(s)">
            <div class="step-bullet" [class.error]="s.error" [class.success]="!s.error">
              <span *ngIf="s.error" nz-icon nzType="close" nzTheme="outline"></span>
              <span *ngIf="!s.error" nz-icon nzType="check" nzTheme="outline"></span>
            </div>
            <div class="step-content">
              <div class="step-title">
                <strong>{{ s.name || s.type || 'Step ' + (i + 1) }}</strong>
                <small *ngIf="s.type">{{ s.type }}</small>
              </div>
              <div class="step-meta">
                <span *ngIf="s.dhStart" class="step-time">{{ s.dhStart }}</span>
                <span *ngIf="s.durationMs != null" class="step-duration">
                  {{ s.durationMs }}ms
                </span>
              </div>
              <div *ngIf="s.error && s.errorMessage" class="step-error-message">
                {{ s.errorMessage }}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section *ngIf="selected" class="step-detail">
        <h4>
          <span nz-icon nzType="info-circle" nzTheme="outline"></span>
          Detalhes: {{ selected.name || selected.key }}
        </h4>
        <nz-collapse nzAccordion>
          <nz-collapse-panel nzHeader="Input" [nzActive]="false">
            <pre class="json-block">{{ formatJson(selected.input) }}</pre>
          </nz-collapse-panel>
          <nz-collapse-panel nzHeader="Output" [nzActive]="!selected.error">
            <pre class="json-block">{{ formatJson(selected.output) }}</pre>
          </nz-collapse-panel>
          <nz-collapse-panel
            *ngIf="selected.error"
            nzHeader="Mensagem de erro"
            [nzActive]="true">
            <nz-alert
              nzType="error"
              nzShowIcon
              [nzMessage]="selected.errorMessage || 'Erro nao especificado'">
            </nz-alert>
          </nz-collapse-panel>
        </nz-collapse>
      </section>

      <section
        *ngIf="!isRunning && state.status === 'COMPLETED' && !state.steps?.length"
        class="empty-result">
        <nz-empty
          nzNotFoundImage="simple"
          nzNotFoundContent="Fluxo concluido. Nenhum step de log retornado pelo servidor.">
        </nz-empty>
      </section>
      </ng-template>

      <footer class="monitor-footer">
        <button
          *ngIf="isRunning"
          nz-button
          nzDanger
          nzType="primary"
          [nzLoading]="stopping"
          (click)="onStop()">
          <span nz-icon nzType="stop"></span>
          Parar execucao
        </button>
        <button
          nz-button
          [nzType]="isRunning ? 'default' : 'primary'"
          (click)="onClose()">
          {{ isRunning ? 'Fechar mesmo assim' : 'Fechar' }}
        </button>
      </footer>
    </div>
  </ng-container>
</nz-drawer>
